import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { TESTIMONIALS } from "../data/content";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-brand-light" data-testid="testimonials-section">
      <div className="container-x">
        <div className="md:flex items-end justify-between mb-14 gap-10">
          <div className="max-w-2xl">
            <Reveal>
              <p className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-4">
                Loved by committees
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-extrabold tracking-tight text-4xl md:text-6xl leading-[0.95]">
                Societies run smoother on grooh.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-2 mt-6 md:mt-0">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} fill="#0033A2" strokeWidth={0} />
                ))}
              </div>
              <span className="font-heading font-bold text-lg">4.9/5 · 1,200+ reviews</span>
            </div>
          </Reveal>
        </div>

        <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <StaggerItem
              key={t.name}
              className={i === 1 ? "md:-translate-y-6" : ""}
            >
              <div
                className="h-full bg-white border-2 border-black rounded-3xl p-8 shadow-hard-sm"
                data-testid={`testimonial-${i}`}
              >
                <Quote size={36} className="text-[#0033A2]" fill="#0033A2" strokeWidth={0} />
                <p className="mt-4 font-heading font-semibold text-xl leading-snug tracking-tight">
                  "{t.quote}"
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <img
                    src={`${t.avatar}?auto=format&fit=crop&w=120&q=80`}
                    alt={t.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-black"
                  />
                  <div>
                    <p className="font-heading font-bold text-lg leading-none">{t.name}</p>
                    <p className="text-black/55 font-medium text-sm mt-1">{t.role}</p>
                  </div>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
